import React from 'react';
interface ShippingModalProps {
  onClose: () => void;
}
export const ShippingModal: React.FC<ShippingModalProps> = ({
  onClose
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-232">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[80vh] overflow-y-auto" data-id="element-233">
        <div className="p-6" data-id="element-234">
          <div className="flex justify-between items-center mb-4" data-id="element-235">
            <h2 className="text-xl font-bold text-gray-800" data-id="element-236">
              Shipping Information
            </h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-237">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-238">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-239" />
              </svg>
            </button>
          </div>
          <div className="prose prose-sm" data-id="element-240">
            <div className="mb-4 p-4 bg-amber-50 border-l-4 border-amber-400 rounded" data-id="element-241">
              <p className="font-bold text-amber-800" data-id="element-242">
                Current Shipping Time: 14 days due to high demand
              </p>
            </div>
            <h3 data-id="element-243">Shipping Details</h3>
            <p data-id="element-244">
              All orders are processed and shipped within 1-2 business days
              after payment confirmation. Due to current high demand, please
              expect delivery within 14 days from the shipping date.
            </p>
            <h3 data-id="element-245">Shipping Methods</h3>
            <p data-id="element-246">
              We use trusted shipping carriers to ensure your book arrives
              safely. Tracking information will be provided via email once your
              order ships.
            </p>
            <h3 data-id="element-247">Shipping Areas</h3>
            <p data-id="element-248">
              We currently ship to all 50 U.S. states and territories.
              International shipping is not available at this time.
            </p>
            <h3 data-id="element-249">Packaging</h3>
            <p data-id="element-250">
              Your book will be carefully packaged to prevent damage during
              transit. Premium Hardcover editions receive extra protective
              packaging.
            </p>
            <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded" data-id="element-251">
              <p className="font-medium" data-id="element-252">
                For any shipping inquiries, please contact our customer service
                team at support@voicesoffreedomus.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};